export default __webpack_public_path__ + "media/images/icons/material-local-phone-cd8fcaad2175e256b359d4c8cb2042ea.svg";